import { AxiosError } from 'axios';
import api from '../../../services/api';
import { AnswerKeyFormRequestProps } from '../types/template.type';

export async function createAnswerKeyRequest(
	data: AnswerKeyFormRequestProps[]
) {
	try {
		const response = await api.post('/template', data);

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
